import { PatchJSON } from "@/lib/http";
import { useForm } from "react-hook-form";
import { Loading } from "notiflix";
import { toast } from "sonner";

const ChangePin = () => {
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      old_pin: "",
      pin: "",
      confirm_pin: ""
    }
  });

  const validatePins = data => {
    if (data.pin.length !== 4) {
      toast.warning("New PIN must be 5 digits long");
      return false;
    }
    if (data.pin !== data.confirm_pin) {
      toast.warning("New PINs do not match");
      return false;
    }
    return true;
  };

  const onSubmit = async data => {
    if (validatePins(data)) {
      Loading.circle("Updating PIN");
      const { err } = await PatchJSON({
        url: "/api/user",
        body: data
      });
      if (!err) {
        toast.success("PIN changed successfully");
        reset();
      } else {
        toast.error(err);
      }
      Loading.remove();
    }
  };

  return (
    <section className="rounded-xl border p-5 shadow-2xl dark:border-darkBorder lg:p-7">
      <form className="space-y-3" onSubmit={handleSubmit(onSubmit)}>
        <div className="space-y-1">
          <label htmlFor="old-pin" className="text-sm font-semibold">
            Old Transaction PIN
          </label>
          <input
            {...register("old_pin", { required: "Old PIN is required" })}
            type="password"
            id="old-pin"
            className="w-full rounded-md border bg-gray-100 p-2 py-3 text-sm dark:border-darkBorder dark:bg-darkInput"
            placeholder="Enter old transaction PIN"
          />
          {errors.old_pin &&
            <p className="text-xs font-medium text-red-500">
              {errors.old_pin.message}
            </p>}
        </div>

        <div className="space-y-1">
          <label htmlFor="new-pin" className="text-sm font-semibold">
            New Transaction PIN
          </label>
          <input
            {...register("pin", { required: "New PIN is required" })}
            type="password"
            id="new-pin"
            className="w-full rounded-md border bg-gray-100 p-2 py-3 text-sm dark:border-darkBorder dark:bg-darkInput"
            placeholder="Enter new transaction PIN"
            maxLength={4}
          />
          {errors.pin &&
            <p className="text-xs font-medium text-red-500">
              {errors.pin.message}
            </p>}
        </div>

        <div className="space-y-1">
          <label htmlFor="confirm-pin" className="text-sm font-semibold">
            Confirm Transaction PIN
          </label>
          <input
            {...register("confirm_pin", {
              required: "Confirm PIN is required"
            })}
            type="password"
            id="confirm-pin"
            className="w-full rounded-md border bg-gray-100 p-2 py-3 text-sm dark:border-darkBorder dark:bg-darkInput"
            placeholder="Enter confirmed new transaction PIN"
            maxLength={4}
          />
          {errors.confirm_pin &&
            <p className="text-xs font-medium text-red-500">
              {errors.confirm_pin.message}
            </p>}
        </div>

        <div className="flex justify-end pt-3">
          <button
            className="rounded-md btn px-4 py-2 font-semibold text-white cursor-pointer"
            type="submit"
          >
            Save Changes
          </button>
        </div>
      </form>
    </section>
  );
};

export default ChangePin;